// extracted by mini-css-extract-plugin
export default {"submitBtnContainer":"cLaBejhacW_iKCBpxfAL","linkContainer":"BNhu4WXBipW4rhnk9LC3","accountManagementLink":"ZKIkWFIRt5WzjlIsNONW"};